import { useMemo } from 'react';

import { useMessageTypes } from '../../../../hooks/queries';
import { useTranslation } from '../../../../hooks/useTranslation';
import { doesMessageTypeMatchSearch } from './doesMessageTypeMatchSearch';

type UseMessageTypeOptionsProps = {
  search: string;
};

export const useMessageTypeOptions = ({ search }: UseMessageTypeOptionsProps) => {
  const { t } = useTranslation();
  const { messageTypes, didError, isLoading } = useMessageTypes();

  const options = useMemo(
    () =>
      messageTypes
        .filter(({ id, name }) => doesMessageTypeMatchSearch(id, name, search))
        .map((messageType) => ({
          title: messageType.name,
          subtitle: t('v2.conditionBuilder.messageTypeSubtitle', { id: messageType.id }),
          value: messageType.id.toString(),
        })),
    [messageTypes, t, search],
  );

  return { options, didError, isLoading };
};
